// apps/token-seek/src/components/HeightRecorderWrapper/HeightRecorderContext.tsx
"use client";

import { createContext, useContext, useEffect } from "react";
import { usePrevious } from "ahooks";

interface HeightRecorderContextValue {
  startObserveHeight: () => void;
  isReady: boolean;
  /** 本 session 内该区块是否曾进入视口，用于返回页面时强制水合 */
  wasVisibleBefore?: boolean;
}

const HeightRecorderContext = createContext<HeightRecorderContextValue | null>(
  null,
);

export const useStartObserveHeight = (
  loading: boolean,
  hasDate: boolean = false,
) => {
  const { startObserveHeight, isReady } =
    useContext(HeightRecorderContext) || {};
  const previousLoading = usePrevious(loading);

  useEffect(() => {
    if (
      startObserveHeight &&
      !isReady &&
      ((previousLoading === true && loading === false) || hasDate)
    ) {
      startObserveHeight();
    }
  }, [isReady, previousLoading, loading]);

  return isReady;
};

export { HeightRecorderContext };
